export function jobInitialData(collectionId: number, webuserId: number, importId: number) {
    return {
        webuser_id: webuserId,
        collection_id: collectionId,
        target_date: null,
        address_id: null,
        coords_set_manually: false,
        client_attributes: {},
        address_attributes: {
            city: '',
            house: '',
            pcode: '',
            street: '',
            country: 'Polska',
            quarter: '',
            province: '',
            community: '',
        },
        special_attributes: {
            type: '',
            phone: '',
            parcels: null,
            total_weight: null,
            deliverydelay: null,
            fill_percentage: null,
            start_of_time_window: null,
            end_of_time_window: null,
            external_id: '',
            latest_delivery_date: null,
            delivery_or_collection: 'delivery',
            earliest_delivery_date: null,
            orderCreatedDate: null,
            label: null
        },
        geom: null,
        job_type_id: 1,
        import_id: importId,
    };
}
